import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { bsc } from 'wagmi/chains';
import { http } from 'wagmi';

// ⚠️ TEST MODE: Using demo Project ID
// For production, get your own Project ID from https://cloud.walletconnect.com/
// 1. Sign up / Log in
// 2. Create new project (name: Scrooge Finance, chain: BNB Chain)
// 3. Copy Project ID and replace below
const PROJECT_ID = 'demo'; // Replace with your real Project ID

export const config = getDefaultConfig({
  appName: 'Scrooge Finance',
  projectId: PROJECT_ID,
  chains: [bsc],
  transports: {
    [bsc.id]: http(),
  },
});
